import React from "react";

const Footer = () => (
	<footer className="bg-yellow-700 text-white py-6 mt-10">
		<div className="text-center text-sm">
			&copy; {new Date().getFullYear()} Lieuriche International Limited. All
			rights reserved.
		</div>
	</footer>
);

export default Footer;
